import React from 'react';
import { ReplyTemplatesManager } from '../../../components';

function ReplyTemplatesForm() {
    return <ReplyTemplatesManager globalOnly />;
}

export default ReplyTemplatesForm;
